import { Button, Input } from 'antd'
import React, { useCallback, useEffect, useMemo, useReducer, useRef, useState } from 'react'
import { ReactComponent as ZipImage } from "../../../../assets/images/uploadZip.svg"
import { ReactComponent as RemoveIcon } from "../../../../assets/images/close-circle.svg"
import { useDropzone } from 'react-dropzone';
import "./style/import-app.scss";
import { useToast } from '../../../../helpers/commonFunction';


interface IPropsUpload {
    appId?: string;
    appNa?: string;
    selectedAppVal?: any;
    setErrorMessage?: boolean;
    visible:any;
    onAppDataChange?: (appId: string, appNa: string, selectedAppVal: any) => void;
}

const UploadApps = ({ appId = "", appNa = "", selectedAppVal = null, setErrorMessage, visible, onAppDataChange }: IPropsUpload) => {

    // hooks
    const [selectedFile, setSelectedFile] = useState<any>(selectedAppVal || null);
    const fileInputRef = useRef<HTMLInputElement | any>(null);
    const [appIdt, setAppIdt] = useState<string>(appId || "");
    const [appName, setAppName] = useState<string>(appNa || "");
    const [isAppNameTouched, setIsAppNameTouched] = useState(false);
    const [isAppIdtTouched, setIsAppIdtTouched] = useState(false);
    const [marginBottom, setMarginBottom] = useState(70);
    const { ErrorToast } = useToast();

    useEffect(() => {
        if (visible.visible === false) {
            setAppIdt("")
            setAppName("")
            setIsAppNameTouched(false)
            setIsAppIdtTouched(false)
            setSelectedFile(null)
        }
    }, [visible, appNa, appId, selectedAppVal])
    
    useEffect(() => {
        if (onAppDataChange) {
            onAppDataChange(appIdt, appName, selectedFile);
        }
    }, [appIdt, appName, selectedFile, onAppDataChange]);

    // functions
    const onDrop = useCallback((acceptedFiles) => {
        const file = acceptedFiles[0];
        if (file && (file.type === 'application/zip' || file.name.endsWith('.zip'))) {
            setSelectedFile(file);
        } else {
            ErrorToast("Please Upload Zip File.")
        }
    }, []);


    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            'application/zip': ['.zip'],
        },
        multiple: false,
    });

    const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        if (event.target.files && event.target.files.length > 0) {
            const selectedFile = event.target.files[0];
            setSelectedFile(selectedFile);
        }
    };
    const handleButtonClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const displayNameOnCh = (e: any) => {
        const re = /^[A-Za-z_][A-Za-z0-9,_/;'"!&@%$-\s]*$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            let val = e.target.value.replace(/[^a-zA-Z0-9_ ]/g, "")
            let value = val.replace(/ /g, "_")
            setAppName(e.target.value)
            setAppIdt(value)
            setIsAppNameTouched(e.target.value === "");
        }
    }

    const displayNameIdeOnc = (e: any) => {
        const re = /^[A-Za-z_][A-Za-z0-9_]*$/;
        if (e.target.value === '' || re.test(e.target.value)) {
            setAppIdt(e.target.value)
            setIsAppIdtTouched(e.target.value === "")
        }
    }

    useEffect(() => {
        const updateMarginBottom = () => {
            let newMarginBottom = 70;
            if (window.innerHeight > 830) {
                newMarginBottom = Math.min(70 + (window.innerHeight - 830), 164);
            }
            setMarginBottom(newMarginBottom);
        };
    
        updateMarginBottom();
        window.addEventListener("resize", updateMarginBottom);
    
        return () => window.removeEventListener("resize", updateMarginBottom);
    }, []);

    return (
        <form
            className='uploadApps'>
            <div className='uploadApps-input-parent'>
                <div className='uploadApps-input'>
                    <span className='app-uploadInput-font'>Display Name <span className='uploadInput-asterisk '>*</span></span>
                    <Input className={`${isAppNameTouched && !appName && 'uploadApp-touched'}`} placeholder='Enter display name'
                        onChange={(event: any) => displayNameOnCh(event)}
                        required={true}
                        onBlur={() => setIsAppNameTouched(true)}
                        value={appName}
                    ></Input>
                </div>
                <div className='uploadApps-input'>
                    <span className='app-uploadInput-font'>Name (Identifier)<span className='uploadInput-asterisk '>*</span></span>
                    <Input className={`${isAppIdtTouched && !appIdt && 'uploadApp-touched'}`} placeholder='Enter name identifier'
                        onChange={(event: any) => displayNameIdeOnc(event)}
                        value={appIdt}
                        onBlur={() => setIsAppIdtTouched(true)}
                        required={true}
                    ></Input>
                </div>
            </div>
            <div className='uploadApps-container'>
                <span style={{ marginTop: "0px" }} className='app-uploadInput-font'>Upload Apps <span className='uploadInput-asterisk '>*</span></span>
                <div style={{ marginBottom: `${marginBottom}px` }} className='upload-zip-parent'>
                    <div className='upload-zip-child' style={{ marginBottom: selectedFile ? "6px" : "16px" }}>
                        <ZipImage />
                    </div>
                    {
                        selectedFile == null ?
                            <> <div
                                {...getRootProps()}
                                className="cursor-pointer transition-colors duration-200"
                            >
                                <input ref={fileInputRef} {...getInputProps()} required />
                                <div className='app-uploadInput-font'>
                                    {isDragActive
                                        ? 'Drop the zip file here'
                                        : selectedFile
                                            ? `${selectedFile.name}`
                                            : 'Drag and drop zip file to upload'}
                                </div>
                            </div>
                                <span className='upload-zip-or'>
                                    or
                                </span>
                                <input
                                    type="file"
                                    ref={fileInputRef}
                                    style={{ display: 'none' }}
                                    accept=".zip"
                                    onChange={handleInputChange}
                                    required
                                />
                                <Button onClick={handleButtonClick} className='upload-zip-button'>
                                    Browse file
                                </Button>
                            </>
                            :
                            <>
                                <div style={{ marginTop: selectedFile ? "0px" : "10px" }} className='app-uploadInput-font app-uploadInput-font-up'>
                                    {isDragActive
                                        ? 'Drop the zip file here'
                                        : selectedFile
                                            ? `${selectedFile.name}`
                                            : 'Drag and drop zip file to upload'}
                                    <span className='app-upl-removeicon' onClick={() => setSelectedFile(null)}>
                                        <RemoveIcon />
                                    </span>
                                </div>
                                {
                                    setErrorMessage &&
                                    <div className='upload-modal-err-message'>
                                        Upload failed, try again or re-upload zip file
                                    </div>
                                }
                            </>
                    }
                </div>
            </div>
        </form>
    )
}

export default UploadApps